// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"46bffa0d","239":"3eb7e6bb","240":"3eb7e6bb","294":"7d1c98f7","489":"3eb7e6bb","798":"d4a5053a","918":"3eb7e6bb"}[chunkId] + ".chunk.css";
};